import React, { useEffect, useState } from 'react';
import './admin.css';
import Modal from 'react-modal';
import { useLocation, useNavigate } from 'react-router-dom';

const Createorder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state?.orderData;
  const fileInputRef = React.useRef(null);

  const [fileBase64, setFileBase64] = useState("");
  const [fileName, setFileName] = useState("");

  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1; // getMonth() is 0-11
  const year = date.getFullYear();
  const fulldate = `${day}-${month}-${year}`;

  const [customersList, setCustomersList] = useState([]);
  const [isRecurring, setIsRecurring] = useState(false);
  const [formData, setFormData] = useState({
    customerName: "",
    businessName: "",
    address: "",
    service: "",
    serviceType: "",
    duration: "",
    startDate: "",
    endDate: "",
    orderValue: "",
    advance: "",
    phone: "",
    email: "",
    website: "",
    gstin: "",
    serviceDetails: "",
    attachment: "",
    attachmentName: ''
  });
  const [newNote, setNewNote] = useState("");
  // Calculate balance automatically
  const balance = Number(formData.orderValue || 0) - Number(formData.advance || 0);

  // Initial load: Fetch customers and check for editData
  useEffect(() => {
    fetchCustomers();
    if (editData) {
      setFormData(editData);
      setIsRecurring(editData.serviceType === "Recurring");
    }
  }, [editData]);

  const fetchCustomers = async () => {
    try {
      const res = await fetch("https://api-zspzr757qa-uc.a.run.app/customers");
      const data = await res.json();
      setCustomersList(data);
    } catch (err) {
      console.error("Error fetching customers:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "customerName") {
      const selectedCustomer = customersList.find(c => c.customerName === value);
      if (selectedCustomer) {
        setFormData((prev) => ({
          ...prev,
          customerName: value,
          businessName: selectedCustomer.businessName || "",
          address: selectedCustomer.address || "",
          phone: selectedCustomer.phone || "",
          email: selectedCustomer.email || "",
          website: selectedCustomer.website || "",
          gstin: selectedCustomer.gstin || "",
        }));
        return;
      }
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectRec = (event) => {
    const value = event.target.value;
    setFormData((prev) => ({
      ...prev,
      serviceType: value,
      duration: value === "Recurring" ? prev.duration : "",
    }));
    setIsRecurring(value === "Recurring");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFileBase64(reader.result);

        alert(`File "${file.name}" attached!`);
      };
    }
  };
  const resetForm = () => {
    setFormData({
      customerName: "",
      businessName: "",
      address: "",
      service: "",
      serviceType: "",
      duration: "",
      startDate: "",
      endDate: "",
      orderValue: "",
      advance: "",
      phone: "",
      email: "",
      website: "",
      gstin: "",
      serviceDetails: ""
    });
    setIsRecurring(false);
  };

  const handleSave = async () => {
    // 1. Determine if we are in Edit Mode
    const isEditing = !!editData;

    // 2. Validation: Check required fields + ensure there's a new update if editing
    const requiredFields = ["customerName", "businessName", "startDate", "orderValue", "advance", "email", "phone"];
    const missingFields = requiredFields.filter(field => !formData[field]);
    const currentEntry = isEditing ? newNote : formData.serviceDetails;

    if (missingFields.length > 0 || !currentEntry.trim()) {
      alert(`Please fill in all required fields and provide ${isEditing ? 'a new update' : 'service details'}.`);
      return;
    }

    // 3. Prepare variables for the merge
    let finalService = formData.service;
    let finalServiceDetails = formData.serviceDetails;

    if (isEditing) {
      const timestamp = new Date().toLocaleString();

      // Combine Service Names (e.g., "Web Dev + SEO") if a new one is picked
      if (formData.service !== editData.service) {
        finalService = `${editData.service} + ${formData.service}`;
      }

      // Combine Details: Existing History + Timestamp + New User Input
      // This ensures the old text is NEVER deleted, only added to.
      finalServiceDetails = `${editData.serviceDetails}\n\n--- Updated on ${timestamp} ---\n${newNote}`;
    }

    const url = isEditing
      ? `https://api-zspzr757qa-uc.a.run.app/orders/${editData._id}`
      : "https://api-zspzr757qa-uc.a.run.app/createorder";
    const method = isEditing ? "PUT" : "POST";

    try {
      const res = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          service: finalService,
          serviceDetails: finalServiceDetails,

          balance: balance,
          serviceType: formData.serviceType || (isRecurring ? "Recurring" : "One Time"),
          attachment: fileBase64 ? fileBase64 : (editData ? editData.attachment : ""),
          attachmentName: fileName || (editData ? editData.attachmentName : ""),
        }),
      });

      if (res.ok) {
        if (isEditing) {

          alert("Customer updated Successfully! ✅");
          setNewNote("");
          resetForm();
          navigate("/admin/customer");
        } else {

          alert("Order Created! ✅");
          setNewNote("");
          resetForm();

        }
      } else {
        const errorData = await res.json();
        alert(`Error: ${errorData.error || "Save failed"}`);
      }
    } catch (err) {
      console.error("Save Error:", err);
      alert("Server connection failed.");
    }
  };
  // Modal Logic
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleaddcustomer = async () => {
    try {
      const res = await fetch("https://api-zspzr757qa-uc.a.run.app/addcustomer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customerName: formData.customerName,
          businessName: formData.businessName,
          address: formData.address,
          phone: formData.phone,
          email: formData.email,
          website: formData.website,
          gstin: formData.gstin
        }),
      });
      if (res.ok) {
        alert("Customer Added Successfully!");
        await fetchCustomers();
        closeModal();
      } else {
        alert("Failed to add customer.");
      }
    } catch (err) {
      console.error("Error adding customer:", err);
    }
  };

  return (
    <div className='container'>
      <div className="d-flex flex-wrap justify-content-between w-100">
        <div>Date : {fulldate}</div>
        <div>OrderID: {editData ? editData.orderId : "Auto-Generated"}</div>
      </div>
      <h5 className='mt-3 bg-theme text-white pt-3 pb-3'>
        {editData ? "Edit / Update Order" : "Create New Order"}
      </h5>

      <div className="d-flex flex-wrap">
        <div className='me-0'>
          <label>Customer Name</label>
          <select name="customerName" className="form-select" value={formData.customerName} onChange={handleChange}>
            <option value="">--Please Select Customer--</option>
            {customersList.map((customer) => (
              <option key={customer._id} value={customer.customerName}>{customer.customerName}</option>
            ))}
          </select>
        </div>
        <label className='mt-5 blur text-success' onClick={openModal}>AddNew+</label>

        <div className='me-3'>
          <label>Business Name</label>
          <input name='businessName' value={formData.businessName} onChange={handleChange} type="text" className='form-control' />
        </div>

        <div className='me-3'>
          <label>Address</label>
          <input name='address' value={formData.address} onChange={handleChange} type="text" className='form-control' />
        </div>

        <div className='me-3'>
          <label>Service</label>
          <select name="service" value={formData.service} onChange={handleChange} className="form-select">
            <option hidden>Select Service</option>
            <option value="Basic Website">Basic Website</option>
            <option value="Wordpress Development">Wordpress Development</option>
            <option value="Application Development">Application Development</option>
            <option value="Ecommerce Website">Ecommerce Website</option>
            <option value="Social Media Marketing">Social Media Marketing</option>
            <option value="SEO Services">SEO Services</option>
            <option value="Youtube Marketing">Youtube Marketing</option>
            <option value="Other Services">Other Services</option>
          </select>
        </div>

        <div className='me-3'>
          <label>Service Type</label>
          <select name="serviceType" value={formData.serviceType} onChange={handleSelectRec} className="form-select">
            <option hidden>Select Type</option>
            <option value="One Time">One Time</option>
            <option value="Recurring">Recurring</option>
          </select>
        </div>

        {isRecurring && (
          <div className='me-3'>
            <label>Select Duration</label>
            <select name="duration" value={formData.duration} onChange={handleChange} className='form-select'>
              <option hidden>--Select--</option>
              <option value="Monthly">Monthly</option>
              <option value="Three-Months">Three-Months</option>
              <option value="Six-Months">Six-Months</option>
              <option value="Twelve-Months">Twelve-Months</option>
            </select>
          </div>
        )}
      </div>

      <div className="d-flex flex-wrap mt-3">
        <div className='me-3'>
          <label>Start Date</label>
          <input name='startDate' value={formData.startDate} onChange={handleChange} type="date" className='form-control' />
        </div>
        <div className='me-3'>
          <label>End Date</label>
          <input name='endDate' value={formData.endDate} onChange={handleChange} type="date" className='form-control' />
        </div>
        <div className='me-3'>
          <label>Order Value</label>
          <input name='orderValue' value={formData.orderValue} onChange={handleChange} type="number" className='form-control' />
        </div>
        <div className='me-3'>
          <label>Advance Payment</label>
          <input name='advance' value={formData.advance} onChange={handleChange} type="number" className='form-control' />
        </div>
        <div className='me-3'>
          <label>Remaining Balance</label>
          <input type="number" value={balance} className='form-control bg-light' readOnly style={{ fontWeight: 'bold', color: balance < 0 ? 'red' : 'green' }} />
        </div>
      </div>

      <div className="mt-3">
        {editData && (
          <div className="mb-3">
            <label className="fw-bold text-muted">Past Service History (Read Only)</label>
            <div
              className="form-control bg-light"
              style={{ whiteSpace: 'pre-wrap', minHeight: '75px', maxHeight: '200px', overflowY: 'auto' }}
            >
              {editData.serviceDetails}
            </div>
          </div>
        )}

        <label className="fw-bold">{editData ? "Add New Update / Note" : "Service Details"}</label>
        <div className="mt-3" style={{ position: 'relative' }}>
          <label className="fw-bold">{editData ? "Add New Update" : "Service Details"}</label>

          <div style={{ position: 'relative' }}>
            <textarea
              className="form-control border-primary"
              rows="3"
              style={{ paddingRight: '45px' }} // Make room for the button
              placeholder="Type new requirements or updates here..."
              value={editData ? newNote : formData.serviceDetails}
              onChange={(e) => {
                if (editData) {
                  setNewNote(e.target.value);
                } else {
                  setFormData({ ...formData, serviceDetails: e.target.value });
                }
              }}
            ></textarea>

            {/* Hidden File Input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />

            {/* Attachment Button */}
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="btn btn-outline-primary btn-sm"
              style={{
                position: 'absolute',
                right: '10px',
                bottom: '10px',
                borderRadius: '50%',
                width: '95px',
                height: '32px',
                padding: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title="Attach File"
            >
              Add File
            </button>
          </div>

          {/* Show selected file name if exists */}
          {fileBase64 && (
            <div className="text-success small mt-1">
              File is  Selected: <strong>{fileName.name}</strong>
              <span
                className="ms-2 text-danger pointer"
                onClick={() => setFileName(null)}
                style={{ cursor: 'pointer' }}
              > (Remove)</span>
            </div>
          )}
        </div>


      </div>


      <button onClick={handleSave} className="btn btn-primary mt-3 d-flex ms-auto">
        {editData ? "Update Record" : "Save Record"}
      </button>

      {/* Customer Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.5)", // overlay handled here
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            borderRadius: "10px",
            width: "40%",
            height: "80%",
          }
        }}
      >
        <button onClick={closeModal} className="btn btn-sm btn-danger float-end">X</button>
        <h3 className="text-center bg-theme text-white mt-2 pt-1 pb-1">Add Customer</h3>
        <div className="p-3">
          <div className="d-flex flex-wrap justify-content-around">
            <div>
              <label>Name</label>
              <input name='customerName' value={formData.customerName} onChange={handleChange} type="text" className='form-control ' />
            </div>
            <div>
              <label>Business Name</label>
              <input name='businessName' value={formData.businessName} onChange={handleChange} type="text" className='form-control mb-2' />
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-around">
            <div>
              <label>Phone</label>
            <input name='phone' value={formData.phone} onChange={handleChange} type="number" className='form-control mb-2' />
            </div>
            <div>
              <label>Email</label>
            <input name='email' value={formData.email} onChange={handleChange} type="text" className='form-control mb-2' />
            </div>
          </div>
          <div className="d-flex flex-wrap justify-content-around">
            <div>
              <label>Address</label>
            <input name='address' value={formData.address} onChange={handleChange} type="text" className='form-control mb-2' />
            </div>
           <div> <label>gstIn</label>
            <input name='gstin' value={formData.gstin} onChange={handleChange} type="number" className='form-control mb-2' /></div>
          </div>
          <div className="mt-4 w-50">
            <label>WebSite</label>
            <input name='website' value={formData.website} onChange={handleChange} type="text" className='form-control mb-2' />
          </div>
          <button onClick={handleaddcustomer} className="btn btn-primary d-flex ms-auto">Save Customer</button>
        </div>
      </Modal>
    </div>
  );
};

export default Createorder;